<template>
  <div class="flex flex-row items-center">
    <div
      class="bg-static-info-mid rounded-sm mr-12 flex h-36 w-36 shrink-0 items-center justify-center"
    >
      <slot name="icon" />
    </div>
    <slot name="content" />
  </div>
</template>

<style scoped>
.bg-static-info-mid {
  background: linear-gradient(to bottom right, #e2f77e 30%, #eedcfc 70%);
}
</style>
